export const setPerspectivesList = (state, data) => {
    state.perspectivesList = [...data];
};

export const setSelectedPerspective = (state, data) => {
    state.selectedPerspective = data || {};
};

export const setDraftSelectedPerspective = (state, data) => {
    state.draftSelectedPerspective = data;
};

export const setPerspectiveId = (state, data) => {
    state.perspectiveId = data;
};

export const setPerspectiveDirty = (state, data) => {
    state.perspectiveDirty = data;
};

export const setSearchPerspectiveData = (state, data) => {
    state.searchPerspectiveData = data;
};
